export const DOCUMENTS = {
  terms: { title: 'Terms of Service', path: '/terms' },
  policy: { title: 'Privacy Policy', path: '/policy' },
} as const;
